import React from "react";
import PropTypes from "prop-types";
const PhotoGridIcon = ({
  noPointer,
  width,
  size,
  height,
  style,
  color = "var(--color-easil-gray-x-dark)",
  title,
  ...props
}) => (
  <svg
    {...props}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
    stroke={color || "var(--color-easil-gray-x-dark)"}
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-2-2h24v24H-2z" />
      <path d="M-2-2h24v24H-2z" />
      <path fill={color} stroke="none" d="M9 2h2v16H9z" />
      <path fill={color} stroke="none" d="M2 9h16v2H2z" />
      <path
        fill={color}
        stroke="none"
        fillRule="nonzero"
        d="M2 2v16h16V2H2zm0-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"
      />
    </g>
  </svg>
);
PhotoGridIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default PhotoGridIcon;
